// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__eai0N","actions":"GroupTable_actions__20hfT","deleteModalFooter":"GroupTable_deleteModalFooter__1kI4M"};